/** Limite do texto da DM do Instagram: 1000 bytes em UTF-8 (não caracteres). */
export const INSTAGRAM_MAX_BYTES = 1000;

export const DELETED_MESSAGE_TEXT = 'Mensagem apagada pelo cliente';

/** Bytes do texto em UTF-8, contados por ponto de código (sem TextEncoder: o ambiente de teste pode não ter). */
export function utf8ByteLength(text: string): number {
  let bytes = 0;
  for (const char of text) {
    const code = char.codePointAt(0) ?? 0;
    bytes += code < 0x80 ? 1 : code < 0x800 ? 2 : code < 0x10000 ? 3 : 4;
  }
  return bytes;
}

/** Chave de idempotência de uma tentativa de envio: a mesma chave nunca envia duas vezes. */
export function newMetaIdempotencyKey(): string {
  const c = (globalThis as { crypto?: { randomUUID?: () => string } }).crypto;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  return `meta-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

/** Texto mostrado de uma mensagem da Meta: apagada some com o texto, editada ganha a marca. */
export function metaMessageDisplay(message: { content?: string | null; state?: string | null }): {
  text: string;
  deleted: boolean;
  edited: boolean;
} {
  if (message.state === 'deleted') return { text: DELETED_MESSAGE_TEXT, deleted: true, edited: false };
  return { text: message.content ?? '', deleted: false, edited: message.state === 'edited' };
}
